module.exports = __webpack_public_path__ + "img/street.bc83d168.png";